export const isMobile = () => {
    return window.innerWidth < 768
}

export const isPc = () => {
    return window.innerWidth >= 768
}

export const getDeviceType = () => {
    if (isMobile()) return 'mobile'
    if (isPc()) return 'pc'
}
